import {Component, ElementRef, OnInit, ViewChild, AfterViewChecked, AfterViewInit, Input, SimpleChanges, OnChanges} from '@angular/core';
import { Auth } from 'aws-amplify';
import {AuthService} from '../auth/auth.service';
import {CognitoUserInterface} from '@aws-amplify/ui-components';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit, AfterViewChecked, AfterViewInit, OnChanges {
  firstNameInput: string ;
  lastNameInput: string ;
  updatedTelegramid = '';
  confirmedTelegramid = '';
  ctx = {fullName: ''};
  // name: string;
  @Input()  telegramid = '';
  email = '';
  // @ViewChild('firstNameInput') nameInputRef: ElementRef;

  updateAttributes(): void{ /*lastName: HTMLInputElement*/
    // const nameInputRefDebug =  this.nameInputRef;
    // this.fullName = this.firstNameInput + ' ' + this.lastNameInput; // .nameInputRef.nativeElement.value
    this.ctx.fullName = this.updatedTelegramid;
    Auth.updateUserAttributes(this.authService.user, {
      'custom:telegramid': this.telegramid,
      name: this.firstNameInput
    }).then(data => {
      console.log(`updateUserAttributes response data ${data}`);
      this.updatedTelegramid = this.telegramid;
    })
      .catch(err => {
        console.log(`updateUserAttributes response err ${err}`);
        if (err.message){
          this.updatedTelegramid = err.message;
        }
      });
  }
  constructor(public authService: AuthService ) {
  }
// only called for/if there is an @input variable set by parent.
  ngOnChanges(changes: SimpleChanges): void {
    const changesMsgs: string[] = [];
  }
  ngAfterViewChecked(): void {
    // viewChild is updated after the view has been checked
    console.log('ngAfterViewChecked');
  }

  ngAfterViewInit(): void {
    // viewChild is set after the view has been initialized
    console.log('AfterViewInit');
    const userObserver /*: Observer<CognitoUserInterface>*/ = {
      next: (data) => {
        // this.zone.run(() => {this.response =  x.toString(); });
        this.telegramid = data.attributes['custom:telegramid'] || '';
        this.email = data.attributes.email || '';
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        // this.calendarDataLoaded = true;
        console.log('complete');
      }
    };
    this.authService.userSubject$.subscribe(userObserver);
  }

  ngOnInit(): void {
    this.telegramid = this.authService.user && this.authService.user.attributes['custom:telegramid'];
    this.email = this.authService.user && this.authService.user.attributes.email;
  }

}

